import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkSession } from '../services/authService';

const RefreshHandler = ({ setIsAuth }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const verifySession = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        const isValid = await checkSession(token);
        setIsAuth(isValid);
        
        if (!isValid) {
          localStorage.removeItem('token');
          if (location.pathname !== '/login') {
            navigate('/login');
          }
        } else if (location.pathname === '/' || location.pathname === '/login') {
          navigate('/home');
        }
      }
    };

    verifySession();

    // Handle storage events (logout from other tabs)
    const handleStorageChange = (e) => {
      if (e.key === 'token') {
        if (!e.newValue) {
          setIsAuth(false);
          if (location.pathname !== '/login') {
            navigate('/login');
          }
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [location, navigate, setIsAuth]);

  return null;
};

export default RefreshHandler;